import { createAction } from 'redux-act';

export const testAction = createAction('Test action');
export const generateInvoicePDF = createAction('Generate Invoice PDF');
